module.exports = __webpack_public_path__ + "77ad5e30a9c48ba4accdc67af945b44e.png";